import { useSelector } from "react-redux"
import styled from "styled-components"
import backdrop from "../../images/img/backdrop.png"
import backdropSoft from "../../images/img/backdrop-soft.png"
import { useEffect, useRef, useState } from "react";
import MessageInputTextArea from "../shared/input/special/MessageInputTextArea";
import aiAvatarLight from "../../images/svg/ai/aiAvatarLight.svg"
import aiAvatarDark from "../../images/svg/ai/aiAvatarDark.svg"
import { useDispatch } from "react-redux";
import { setInitUserMessage, updateAiChat } from "../../features/ai/aiSlice";
import SmallSpinner from "../shared/spinners/SmallSpinner";
import { BsFillSendFill } from "react-icons/bs";
const Container = styled.div`
    width: calc(100% - 290px);
    height: 70vh;
    border-radius: 10px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    background-image: ${({thm}) => thm === "light" ? `url(${backdrop})` : `url(${backdropSoft})`};
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .top-text {
        width: 100%;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 15px;

        .text-gradient{
            font-size: 2.8rem;
            font-weight: var(--font-weight-xl);
            background: linear-gradient(90deg, #5481EC 0%, #AA6EB4 33%, #D56676 66%, #D86672 100%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
        }

        .q{
          font-size: 2rem;
          color: ${({theme}) => theme.mainTextColor};
          font-weight: var(--font-weight-lg);
        } 
    }

    .chat-container{
        height: calc(100% - 120px);
        width: 100%;
        border-top: 1px solid rebeccapurple;
        padding: 15px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        position: relative;

        
        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .layout{
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.8);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            div{
                font-size: 2.5rem;
                font-weight: var(--font-weight-lg);
                color: #fff;
                text-align: center;
            }
        }
   
    }

    .textarea-container{
        width: 100%;
        border-top: 1px solid rebeccapurple;
        padding: 15px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        position: sticky;
        bottom: 0;
        display: flex;
        align-items: center;
        
        .send-btn{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: var(--color-main);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-left: 10px;
            border: 1px solid transparent;
            
            &:disabled{
                cursor: initial;
                border-color: ${({theme}) => theme.mainBgColor};
                background-color: ${({theme}) => theme.secondaryBgColor};
            }

            .send-icon{
                font-size: 1.5rem;
                color:#fff;
            }
        }
    }

    .ramaining-error-container{
        width: 100%;
        border-top: 1px solid rebeccapurple;
        padding: 15px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        position: sticky;
        bottom: 0;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-md);
        text-align: center;
    }

`


const UserChatItemContainer = styled.div`
    margin: 10px 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    
    .chat-item-wrapper{
        position: relative;
        padding: 10px 20px;
        border-radius: 10px;
        background-color: var(--color-main);
        color: #fff;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        max-width: calc(100% - 35px);
        width: auto;
        display: flex;
        align-items: center;
        gap: 10px;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            right: -10px;
            border-width: 13px;
            border-style: solid;
            border-radius: 1px;
            border-color: var(--color-main) transparent transparent transparent;
        }
    }
    

`

const AiChatItemContainer = styled.div`
    margin: 10px 0;
    width: 60%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;


    .ai-logo-wrapper{
        width: 35px;
        height: 35px;

        img{
            width: 100%;
            height: 100%;
        }
    }
    
    .chat-item-wrapper{
        position: relative;
        padding: 10px 20px;
        border-radius: 10px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        color: ${({theme}) => theme.mainTextColor};
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        line-height: 1.5;
        max-width: calc(100% - 35px);
        width: auto;
        display: flex;
        align-items: center;
        gap: 10px;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: -10px;
            border-width: 13px;
            border-style: solid;
            border-radius: 1px;
            border-color: ${({theme}) => theme.secondaryBgColor} transparent transparent transparent;
        }

 
    }
    
`

const AiChatContainer = () => {

    const {
        aiChatContent,
        messageList,
        initUserMessage,
        initAiMessage,
        isLoadingGetAiChatMessagesById,
        aiRemainingUsage,
        isLoadingUpdateAiChat,
    }  = useSelector(state => state.ai)

    const chatContainerRef = useRef(null);

    const {theme}  = useSelector(state => state.layout)

    const dispatch = useDispatch()

    const [isDragging, setIsDragging] = useState(false)

    const [file, setFile] = useState(null)


    //! bu kullanıcının input a yazdığı mesaj
    const [initUserText, setInitUserText] = useState("")

    const [isLoadingAiResponse, setIsLoadingAiResponse]  = useState(false)

    //! bu user ın mesajını gönderip göndermediğini tutmak için
    const [isSended, setIsSended] = useState(false)
    
    
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
          }
    },[messageList.length, chatContainerRef.current])


    const handleDragLeave = (event) => {
        // Eğer fare div sınırları dışına çıkıyorsa isDragging'i false yap
        if (!chatContainerRef.current.contains(event.relatedTarget)) {
          setIsDragging(false);
        }
    };

   //! drag drop


   const handleSendMessage = () => {
    if (initUserText.trim() === "") return;
    // ChatGPT’den yanıt al
     if(aiChatContent?.chatId){
         dispatch(updateAiChat({
            chatId: aiChatContent?.chatId,
            userMessage: initUserText
         }))
         setInitUserText("");

     }
     else{
         dispatch(updateAiChat({
            chatId: null,
            userMessage: initUserText
         }))
         setInitUserText("");

     }
};


    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            // handleSubmit();
            setIsSended(true)
            handleSendMessage()
        }
    };


  return (
    <Container thm={theme}>
        <div className="top-text">
            <span className="text-gradient">Merhabalar</span>
            <span className="q">Bugün nasıl yardımcı olabilirim?</span>
        </div>

        <div className="chat-container" ref={chatContainerRef}>
        {/* <div className="chat-container" ref={chatContainerRef} isDragging={isDragging} onDrop={handleDrop} onDragOver={handleDragOver} onDragEnd={() => setIsDragging(false)}> */}
            {/* {
                isDragging && 
                <div className="layout">
                    <div>Dosyayı Buraya Bırakabilirsin</div>
                </div>
            } */}
            {
                isLoadingGetAiChatMessagesById ? 
                <SmallSpinner size={"40px"} color={"#fff"} bgColor={"#E85446"}/>
                :
                <>
            {
                messageList?.map((item, i) => {
                    if(item.isFromUser) {
                        return (
                            <UserChatItemContainer key={i}>
                                <div className="chat-item-wrapper">
                                    <span>{item.message}</span>
                                </div>
                            </UserChatItemContainer>
                        )
                    }
                    else{
                        return (
                            <AiChatItemContainer key={i}>
                                    <div className="ai-logo-wrapper">
                                        <img src={theme === "light" ? aiAvatarLight : aiAvatarDark} className="ai-logo" alt="" />
                                    </div>
                                <div className="chat-item-wrapper">
                                    <span>{item.message}</span>
                                </div>
                            </AiChatItemContainer>
                        )
                    }
                })
            }

            {
                (initUserMessage && isSended) && 
                    <UserChatItemContainer>
                        <div className="chat-item-wrapper">
                            <span>{initUserMessage}</span>
                        </div>
                    </UserChatItemContainer>
            }

            {
                (initAiMessage && isLoadingUpdateAiChat) &&
                <AiChatItemContainer>
                    <div className="ai-logo-wrapper">
                        <img src={theme === "light" ? aiAvatarLight : aiAvatarDark} className="ai-logo" alt="" />
                    </div>
                    <div className="chat-item-wrapper">
                        <span>{initAiMessage}</span>
                    </div>
                </AiChatItemContainer>
            }
            </>
        }

        </div>

        {
            aiRemainingUsage === true &&
            <div className="textarea-container">
                <MessageInputTextArea onKeyDown={(e) => {handleKeyDown(e)}} data={initUserText} setData={(e) => {setInitUserText(e.target.value);dispatch(setInitUserMessage(e.target.value)) ; setIsSended(false)}} name={"message"} labelText={""} inputWidth={"100%"}  />
                <button className="send-btn" onClick={() =>  {handleSendMessage(); setIsSended(true)}} disabled={(initUserMessage.trim() === "") || (isLoadingAiResponse)}>
                    <BsFillSendFill className="send-icon" />
                </button>
            </div>
        }
        {
            !aiRemainingUsage && 
        <div className="ramaining-error-container">Günlük kullanım hakkınız dolmuştur.</div>
        }
    </Container>
  )
}

export default AiChatContainer